import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { supabase } from "./lib/supabase";

if (import.meta.env.DEV) {
  window.addEventListener('error', (event) => {
    console.error('[REACT] Global error:', event.error);
  });
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[REACT] Unhandled promise rejection:', event.reason);
  });
}

async function handlePathRedirects(): Promise<boolean> {
  const path = window.location.pathname;
  const hash = window.location.hash;
  const search = window.location.search;

  if (path === '/auth/callback' && hash && !hash.startsWith('#/')) {
    const params = new URLSearchParams(hash.substring(1));
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (accessToken) {
      try {
        await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken || '',
        });
        window.location.replace(window.location.origin + '/#/');
      } catch {
        window.location.replace(window.location.origin + '/#/login?error=google_auth_failed');
      }
      return true;
    }
  }

  const publicPaths = ['/checklist/', '/public/post'];
  const needsRedirect = publicPaths.some(p => path.startsWith(p));

  if (needsRedirect && (!hash || !hash.startsWith('#/'))) {
    window.location.replace(window.location.origin + '/#' + path + search);
    return true;
  }

  return false;
}

handlePathRedirects().then((handled) => {
  if (!handled) {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  }
});
